"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = exports.getInputWidthClass = exports.InputWidthProptypesAuto = exports.InputWidthProptypes = exports.InputWidthClasses = exports.InputWidths = void 0;

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/some"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _Utils = _interopRequireDefault(require("../../util/Utils.js"));

var _InputWidthClasses, _context;

/**
 * @enum {string}
 * @alias InputWidths
 */
var InputWidths = {
  /** XS */
  XS: "XS",

  /** SM */
  SM: "SM",

  /** MD */
  MD: "MD",

  /** LG */
  LG: "LG",

  /** XL */
  XL: "XL",

  /** XX */
  XX: "XX",

  /** MAX */
  MAX: "MAX",

  /** AUTO */
  AUTO: "AUTO"
};
exports.InputWidths = InputWidths;
var InputWidthClasses = (_InputWidthClasses = {}, (0, _defineProperty2.default)(_InputWidthClasses, InputWidths.AUTO, "input-width-auto"), (0, _defineProperty2.default)(_InputWidthClasses, InputWidths.XS, "input-width-xsmall"), (0, _defineProperty2.default)(_InputWidthClasses, InputWidths.SM, "input-width-small"), (0, _defineProperty2.default)(_InputWidthClasses, InputWidths.MD, "input-width-medium"), (0, _defineProperty2.default)(_InputWidthClasses, InputWidths.LG, "input-width-large"), (0, _defineProperty2.default)(_InputWidthClasses, InputWidths.XL, "input-width-xlarge"), (0, _defineProperty2.default)(_InputWidthClasses, InputWidths.XX, "input-width-full"), (0, _defineProperty2.default)(_InputWidthClasses, InputWidths.MAX, "input-width-max"), (0, _defineProperty2.default)(_InputWidthClasses, InputWidths.AUTO, "input-width-auto"), _InputWidthClasses);
exports.InputWidthClasses = InputWidthClasses;
var InputWidthProptypes = [InputWidths.XS, InputWidths.SM, InputWidths.MD, InputWidths.LG, InputWidths.XL, InputWidths.XX, InputWidths.MAX];
exports.InputWidthProptypes = InputWidthProptypes;
var InputWidthProptypesAuto = (0, _concat.default)(_context = []).call(_context, InputWidthProptypes, [InputWidths.AUTO]);
exports.InputWidthProptypesAuto = InputWidthProptypesAuto;

var getInputWidthClass = function getInputWidthClass(_ref) {
  var _context2;

  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      _ref$defaultClass = _ref.defaultClass,
      defaultClass = _ref$defaultClass === void 0 ? InputWidthClasses.MD : _ref$defaultClass,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? null : _ref$width;
  var hasClass = (0, _some.default)(_context2 = (0, _values.default)(InputWidthClasses)).call(_context2, function (value) {
    return (0, _indexOf.default)(className).call(className, value) > -1;
  });

  if (hasClass && !_Utils.default.isProduction()) {
    _Utils.default.deprecateWarn("'input-width-*' CSS classes", "the input 'width' prop");
  }

  return hasClass ? null : InputWidthClasses[width] || defaultClass;
};

exports.getInputWidthClass = getInputWidthClass;
var _default = InputWidths;
exports.default = _default;